import React from 'react';

const PageContainer = ({ as: Component = 'div', className = '', children }) => {
  const classes = ['u-page-container', className].filter(Boolean).join(' ');

  return <Component className={classes}>{children}</Component>;
};

export default PageContainer;
